"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useFormValidation = function useFormValidation(callback) {
  var _useState = (0, _react.useState)({}),
    data = _useState[0],
    setData = _useState[1];
  var _useState2 = (0, _react.useState)({}),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    isValid = _useState3[0],
    setValidity = _useState3[1];
  var _useState4 = (0, _react.useState)(false),
    isSubmitting = _useState4[0],
    setIsSubmitting = _useState4[1];
  (0, _react.useEffect)(function () {
    if (isValid) {
      callback(data, isSubmitting);
      setIsSubmitting(false);
    }
  }, [callback, data, isSubmitting, isValid]);
  var handleData = function handleData(value, name) {
    console.log('yo');
    setIsSubmitting(false);
    var newData = _extends({}, data);
    newData[name] = value;
    // setData(newData);
  };

  var handleError = function handleError(error) {
    if (error.errors.length) {
      setIsSubmitting(false);
      errors[error.name] = error.errors;
    } else {
      delete errors[error.name];
    }
    setErrors(errors);
    setValidity(Object.keys(errors).length === 0);
  };
  var handleValidation = {
    onChange: function onChange(value, name) {
      return handleData(value, name);
    },
    onError: function onError(error) {
      return handleError(error);
    }
  };
  var handleSubmit = function handleSubmit(event, dataToSubmit, errorsToDisplay) {
    event.persist();
    event.preventDefault();
    setIsSubmitting(true);
    // console.log('handleSubmit');
    setData(dataToSubmit);
    setErrors(errorsToDisplay);
    setValidity(Object.keys(errorsToDisplay).length > 0);

    // Trigger each element to validate
    // There is probably a better way of doing it
    [].concat(event.target.elements).forEach(function (element) {
      element.focus();
    });
  };
  return [data, errors, isValid, {
    handleData: handleData,
    handleError: handleError,
    handleValidation: handleValidation,
    handleSubmit: handleSubmit
  }];
};
var _default = exports.default = useFormValidation;